import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Paper, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import { commonResourceStyle } from '../../css/style';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';

const styles = commonResourceStyle();

class ProductItems extends Component {
  componentDidMount = () => {
    const {
      actions, loading, products, apiToken, match,
    } = this.props;
    const { resource, subResource, resourceId } = match.params;

    if (loading === false) {
      if (!products) {
        new Promise((resolve, reject) => {
          actions.getAllResources(apiToken, resource).then(() => actions.getAllResources(apiToken, resource, resourceId, subResource));
          resolve();
        }).catch();
      } else {
        const productItems = this.retrieveItems();
        if (!productItems) {
          actions.getAllResources(apiToken, resource, resourceId, subResource);
        }
      }
    }
  }

  retrieveItems = () => {
    const { products, match } = this.props;
    const { resourceId } = match.params;
    const currentProduct = products.find(product => product.id == resourceId);
    return currentProduct ? currentProduct.items : [];
  }

  render() {
    const {
      products, actions, loading, apiToken, match,
    } = this.props;
    const { resource, resourceId, subResource } = match.params;
    let itemsData = (products && products.length > 0) ? (products.filter(prod => prod.id == resourceId)[0].items) : [];
    itemsData = itemsData || [];
    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Product Item</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} resourceId={resourceId} />
              </div>
            </div>
            <Paper style={styles.paper}>
              <DisplayResources
                data={itemsData}
                actions={actions}
                fieldNames={resourceFields.items}
                resourceName="items"
                apiToken={apiToken}
              />
            </Paper>
          </div>
        )
    );
  }
}

ProductItems.propTypes = {
  loading: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  apiToken: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

ProductItems.defaultProps = {
  products: null,
};

export default withRouter(ProductItems);
